import React from "react";
import ReactPlayer from "react-player";
import "./media-player.css";

const MediaPlayer = ({ url }) => (
  <div className="player-wrapper">
    <ReactPlayer
      src={url}
      controls={true}
      width="100%"
      height="100%"
      className="react-player"
    />
  </div>
);

export default MediaPlayer;